import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "./AddRoutesJson";
import LayoutWrapper from "./LayoutWrappers";
import PrivateRoutesAuth from "./PrivateRoutesAuth";
import {
  COOKIE_CONSTANTS,
  GET_COOKIE_BY_NAME,
} from "../../helpers/cookieHelper";
import {
  GET_LOCAL_STORAGE,
  LOCAL_STORAGE_KEY,
} from "../../helpers/localStorage";
const RouterMain = () => {
  // const userRoles =
  //   GET_COOKIE_BY_NAME(COOKIE_CONSTANTS?.USER)["custom:roles"]?.split(",") ||
  //   [];      userRoles?.some((userRole) => route?.accessTo?.includes(userRole))
  const userRole = GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.selectedRole);
  const renderRoute = () => {
    return PRIVATE_ROUTES.filter((route) =>
      route?.accessTo?.includes(userRole)
    ).map((route, index) => (
      <Route
        key={"_key_Id_Pro" + index + route.path}
        path={route.path}
        element={
          <LayoutWrapper layoutIdentifier={route.layoutType}>
            <Suspense fallback={route.loadingFallback}>
              {route.component}
            </Suspense>
          </LayoutWrapper>
        }
      />
    ));
  };
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* ---Public routes-------- */}
          {PUBLIC_ROUTES.map((route, index) => (
            <Route
              key={"_key_Id_" + index + route.path}
              path={route.path}
              element={
                <LayoutWrapper layoutIdentifier={route.layoutType}>
                  <Suspense fallback={route.loadingFallback}>
                    {route.component}
                  </Suspense>
                </LayoutWrapper>
              }
            />
          ))}
          {/* ---Public routes End-------- */}
          <Route element={<PrivateRoutesAuth />}>
            {/* ---Private routes */}
            {renderRoute()}
            {/* ---Private routes end*/}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RouterMain;
